import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--bg-start)] to-[var(--bg-end)]"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <img src="/images/logo.png" alt="Toritech Logo" className="w-16 h-16" />
        </div>

        {/* Loading animation */}
        <div className="relative">
          {/* Outer ring */}
          <div className="w-12 h-12 border-4 border-[var(--accent-primary)] opacity-20 rounded-full"></div>
          
          {/* Spinning inner ring */}
          <div className="absolute top-0 left-0 w-12 h-12">
            <div className="w-12 h-12 border-4 border-transparent border-t-[var(--accent-primary)] rounded-full animate-spin"></div>
          </div>

          {/* Pulsing dot */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1.5 -translate-y-1.5 w-3 h-3 bg-[var(--accent-primary)] rounded-full animate-pulse"></div>
        </div>

        {/* Loading text */}
        <div className="mt-4 text-[var(--text-primary)] font-medium animate-pulse">
          Loading...
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen; 